export default {

	init() {
		console.log('breadcrumb init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
        document.querySelectorAll('[data-breadcrumb]').forEach(elem => {
            var $trigger = $(elem);
            var $parent = $trigger.parent('li');
            var $target = $parent.find('.dropdown');

            $parent.on('mouseenter', function() {
                $trigger.attr('aria-expanded', 'true');
                $target.removeClass('is-active').addClass('is-active');
            }).on('mouseleave', function() {
                $trigger.attr('aria-expanded', 'false');
                $target.removeClass('is-active');
            });
        });
	}
}